module.exports = __webpack_public_path__ + "static/media/app.133967c4.svg";